import React from 'react';
import { Modal, Form, Input, Switch, message } from 'antd';
import { superInspectionApi } from '../../services/api';

const InspectionAdminFormModal = ({ open, editing, onClose, onSuccess }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (open) {
      form.resetFields();
      if (editing) {
        form.setFieldsValue({ nickname: editing.nickname, isActive: !!editing.is_active });
      } else {
        form.setFieldsValue({ isActive: true });
      }
    }
  }, [open, editing]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editing) {
        await superInspectionApi.update(editing.id, { nickname: values.nickname, isActive: values.isActive ? 1 : 0 });
        message.success('更新成功');
      } else {
        await superInspectionApi.create({ username: values.username, password: values.password, nickname: values.nickname });
        message.success('创建成功');
      }
      onSuccess();
    } catch (err) {
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      }
    }
  };

  return (
    <Modal
      title={editing ? '编辑国检账号' : '新增国检账号'}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="确定"
      cancelText="取消"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        {!editing && (
          <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input placeholder="请输入用户名" />
          </Form.Item>
        )}
        {!editing && (
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '密码至少6位' }]}>
            <Input.Password placeholder="请输入密码" />
          </Form.Item>
        )}
        <Form.Item name="nickname" label="昵称">
          <Input placeholder="请输入昵称" />
        </Form.Item>
        <Form.Item name="isActive" label="启用" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InspectionAdminFormModal;
